import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../localization/language';
import { TERM_OF_SERVICE_URL, PRIVACY_URL } from '../constants';

class Footer extends React.Component {
	render() {
		var tosUrl = TERM_OF_SERVICE_URL[this.props.language.country];
		var privacyUrl = PRIVACY_URL[this.props.language.country];
		return (
			<footer className="footer-wrap">
				<div className="footer">
					<div className="footer__copyright">
						{trans('footer_copyright')}
					</div>
					<nav className="footer__link-wrap">
						<div className="footer__link">
							<a href={tosUrl} className="footer__link-txt">{trans('footer_terms')}</a>
						</div>
						<div className="footer__link">
							<a href={privacyUrl} className="footer__link-txt">{trans('footer_privacy')}</a>
						</div>
					</nav>
				</div>
			</footer>
		);
	}
}

function mapStateToProps(state) {
	return {
		language: state.data.language
	}
}

export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./app/components/Footer.js